// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"SiloTooltip_tooltip__2dt_X","tooltipTextContainer":"SiloTooltip_tooltipTextContainer__1DlrT"};